/* eslint-disable no-param-reassign */
import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withHotelCenterSiteMap,
  siteMapPropType,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { StyledSubPageMenu } from '@bingads-webui-campaign-react/sub-page-menu';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';

const hotelCenterPageCategory = {
  'hotel-center-overview': true,
  'hotel-center-assignment': true,
  'hotel-center-intelligence': true,
  'hotel-center-setup': true,
  feedupload: true,
  report: true,
  adExtensions: true,
  reconciliationreport: true,
};

const idsToHideChildren = ['hotel-center-overview'];

const locateSiteMap = (siteMap, category) => {
  const dfsSearch = (target, options) => {
    const { getChildren, predicate, onFound } = options;

    if (predicate(target)) {
      onFound(target);

      const children = getChildren(target);
      _.each(children, x => dfsSearch(x, options));
    }
  };

  const virtualRoot = { children: siteMap, selected: true };
  const selectedRoad = [];
  const searchOptions = {
    getChildren: x => x.children || [],
    predicate: x => x.selected === true,
    onFound: x => selectedRoad.push(x),
  };

  dfsSearch(virtualRoot, searchOptions);

  const deepestNodeWithCategory = _.chain(selectedRoad)
    .map(x => (category[x.id] ? x : null))
    .compact()
    .last()
    .value();

  // No mapped category found, the sub page menu will be blank
  if (!deepestNodeWithCategory) {
    return [];
  }


  if (_.indexOf(idsToHideChildren, deepestNodeWithCategory.id) !== -1) {
    deepestNodeWithCategory.children = [];
  }

  // Normal category with children
  if (deepestNodeWithCategory.children && deepestNodeWithCategory.children.length > 0) {
    return [deepestNodeWithCategory];
  }

  // Category with no children, will create a vertual node to contain it
  const nodeWrapper = _.clone(deepestNodeWithCategory);
  nodeWrapper.children = [deepestNodeWithCategory];

  return [nodeWrapper];
};

export const Loader = (props) => {
  const { siteMap, updateAvailability } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const available = !_.isEmpty(selectedParent);
  useEffect(() => {
    updateAvailability(available);
  });

  const relocatedSiteMap = locateSiteMap(siteMap, hotelCenterPageCategory);
  return props.isVisible ? (
    <Scenario name="sub-page-memu">
      <Activity name="hotel-center-sub-page-memu">
        <StyledSubPageMenu {...props} siteMap={relocatedSiteMap} />
      </Activity>
    </Scenario>) : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool.isRequired,
  changeLayout: PropTypes.func.isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const HotelCenterSubPageMenuLoader = withHotelCenterSiteMap(
  React.memo(Loader),
  processorSet.all
);
